const defaultFetchConfigs = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
};

const addToCartReducerFactory = ({ DEFAULT_ACTIONS, publish }) =>
    /**
     * See https://shopify.dev/api/ajax/reference/cart#post-locale-cart-add-js
     * @param {any} action An object that contains `items` which contains the list of products to add.
     * @returns A promise that resolves to an object containing the updates of the cart
     */
    async (action) => {
        const payload = { ...defaultFetchConfigs };
        payload.body = JSON.stringify(action);

        const {
            ADD_TO_CART,
            CART_CHANGE_IN_PROGRESS,
            CART_CHANGE_DONE,
            ADD_TO_CART_ERROR
        } = DEFAULT_ACTIONS;

        try {
            publish(CART_CHANGE_IN_PROGRESS, { from: ADD_TO_CART, cart: action });
            const response = await fetch(`${routes.cart_add_url}`, payload);
            const cartUpdates = await response.json();


            const responseCart = await fetch(`/cart.json`);

            
            // WARNING: 
            // This is a customisation done by Mike as this is missing from the original
            // sm-cart library as Mike needed to get all the cart items after adding an item to cart
            const cartUpdatesAll = await responseCart.json();

            window.cartQtyTracker = {};
            for(let i = 0; i < cartUpdatesAll.items.length; i++) {
                window.cartQtyTracker[cartUpdatesAll.items[i].id] = cartUpdatesAll.items[i].quantity;
            }

            console.log("cdebug responseCart", window.cartQtyTracker);

            

            const { status, description } = response;
            const rest = { status, description };
            return { type: ADD_TO_CART, rest, action, cartUpdates, cartUpdatesAll };
        } catch (error) {
            publish(ADD_TO_CART_ERROR, {
                source: "addToCart Reducer",
                action,
                error
            });

            throw error;
        } finally {
            publish(CART_CHANGE_DONE, { from: ADD_TO_CART });
        }
    }

const changeCartReducerFactory = ({ DEFAULT_ACTIONS, publish }) =>
    /**
     * https://shopify.dev/api/ajax/reference/cart#post-locale-cart-change-js
     * @param {any} action - The changes you need to happen, you may use either `line` or `id`. see https://shopify.dev/api/ajax/reference/cart#identify-the-line-item-to-change
     * @returns A promise that resolves to an object containing the updates of the cart
     */
    async (action) => {
        const payload = { ...defaultFetchConfigs };
        payload.body = JSON.stringify(action);

        const {
            CHANGE_CART,
            CART_CHANGE_IN_PROGRESS,
            CART_CHANGE_DONE,
            CHANGE_CART_ERROR
        } = DEFAULT_ACTIONS;

        try {
            publish(CART_CHANGE_IN_PROGRESS, action);
            const response = await fetch(`${routes.cart_change_url}`, payload);
            const cartUpdates = await response.json();

            const responseCart = await fetch(`/cart.json`);
            const cartUpdatesAll = await responseCart.json();

            window.cartQtyTracker = {};
            for(let i = 0; i < cartUpdatesAll.items.length; i++) {
                window.cartQtyTracker[cartUpdatesAll.items[i].id] = cartUpdatesAll.items[i].quantity;
            }

            console.log("cdebug responseCart", window.cartQtyTracker);

            const { status, description } = response;
            const rest = { status, description };
            return { type: CHANGE_CART, rest, action, cartUpdates };
        } catch (error) {
            publish(CHANGE_CART_ERROR, {
                source: "changeCart Reducer",
                action,
                error
            });

            throw error;
        } finally {
            publish(CART_CHANGE_DONE, { from: CHANGE_CART });
        }
    }

const removeFromCartReducerFactory = (SMCart) =>
    /**
     * Uses changeCartReducerFactory as a verbose way to remove cart line items. 
     * Basically calls change chart and sets the quantity to 0.
     * https://shopify.dev/api/ajax/reference/cart#post-locale-cart-change-js
     * @param {string} key - The line item key that looks like 44421662114095:ef0a087ac399582ff43a0b927d63fc6f. See https://shopify.dev/api/liquid/objects/line_item#line_item-key
     * @returns A promise that resolves to an object containing the updates of the cart
     */
    async (key) => {
        const changeCart = changeCartReducerFactory(SMCart);
        return await changeCart({
            id: key,
            quantity: 0
        });
    }

const onGenericError = () => (action) => {
    const { source, error } = action;
    console.error(`An error occured when executing ${source}`);
    console.error(error);
    //  Do more things to the error if necessary
    return action;
}

const assertRootVariablesPlaced = () => {
    if (!routes) {
        throw new Error("Will not be able to use shopify cart related functionality due to missing `routes` in the theme scripts.");
    }

    if (!routes.cart_add_url || !routes.cart_change_url) {
        throw new Error("The urls `cart_add_url` and `cart_change_url` are required in routes.");
    }
}

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        factory(exports);
    } else {
        factory((root.SMCart = { cart: {} }));
    }
}(typeof self !== 'undefined' ? self : this, function (exports) {
    const subscribers = {};
    const reducers = {};

    const debug = () => {};

    exports.getCart = async () => {
        const response = await fetch(`/cart.json`);
        return await response.json();
    };

    exports.subscribe = (type, callback) => {
        if (subscribers[type] === undefined) {
            subscribers[type] = []
        }

        subscribers[type] = [...subscribers[type], callback];

        debug(`Subscribing ${type}`);
        return function unsubscribe() {
            subscribers[type] = subscribers[type].filter((cb) => {
                return cb !== callback
            });
        }
    };
    exports.on = exports.subscribe;

    exports.dispatch = async (action) => {
        const { type } = action;
        debug(`Dispatching ${type}`);
        let reducerOutput = { ...action };
        if (reducers[type]) {
            reducerOutput = await reducers[type].reduce(async (_, reducer) => {
                return await reducer({ ...reducerOutput });
            }, Promise.resolve());
        }

        debug(`Reducers processed ${type}`);
        const output = { ...action, ...reducerOutput };
        debug(`Publishing ${type}. Output below:`);
        debug({ output })
        exports.publish(type, output);
        return output;
    }

    exports.publish = (type, data) => {
        if (subscribers[type]) {
            debug(`Publishing ${type} to ${subscribers[type].length} subscribers`);
            subscribers[type].forEach((callback) => {
                callback(data)
            })
        } else {
            debug(`No subscribers for ${type}`);
        }
    }

    /**
     * 
     * @param {string} type The type of event this reducer gets called on
     * @param {function} reducerFactory Pass in a higher order function `const addToCart = (SMCart) => (action) => {...}
     * @returns 
     */
    exports.registerReducer = (type, reducerFactory) => {
        if (reducers[type] === undefined) {
            reducers[type] = []
        }

        reducers[type] = [...reducers[type], reducerFactory(exports)];

        return function removeReducer() {
            reducers[type] = reducers[type].filter((cb) => {
                return cb !== callback
            });
        }
    }

    /**
     * For when you intend to overwrite reducers instead of writing on top of them.
     * @param {string} type 
     */
    exports.clearReducers = (type) => {
        reducers[type] = [];
    }

    exports.DEFAULT_ACTIONS = {
        CART_CHANGE_IN_PROGRESS: "changeInProgress",
        CART_CHANGE_DONE: "changeDone",
        ADD_TO_CART: "addToCart",
        ADD_TO_CART_ERROR: "addToCart.error",
        CHANGE_CART: "changeCart",
        CHANGE_CART_ERROR: "changeCart.error",
        REMOVE_FROM_CART: "removeFromCart",
    }

    assertRootVariablesPlaced();

    const { ADD_TO_CART, CHANGE_CART, REMOVE_FROM_CART, ADD_TO_CART_ERROR, CHANGE_CART_ERROR } = exports.DEFAULT_ACTIONS;
    exports.registerReducer(ADD_TO_CART_ERROR, onGenericError);
    exports.registerReducer(CHANGE_CART_ERROR, onGenericError);

    exports.registerReducer(ADD_TO_CART, addToCartReducerFactory);
    exports.registerReducer(CHANGE_CART, changeCartReducerFactory);
    exports.registerReducer(REMOVE_FROM_CART, removeFromCartReducerFactory);

    //  Also allow for direct access in case Mike needs it
    //  Ideally though, actions should just be dispatched
    exports.addToCart = addToCartReducerFactory(exports);
    exports.changeCart = changeCartReducerFactory(exports);
    exports.removeFromCart = removeFromCartReducerFactory(exports);

}));